"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; } const formatCount = (n) => n.toLocaleString('en-US'); exports.formatCount = formatCount

 const pluralize = (n, one, many) =>
  `${exports.formatCount.call(void 0, n)} ${n === 1 ? one : many}`; exports.pluralize = pluralize









// Some engines put a narrow no-break space before AM/PM; keep one plain space.
const plainSpaces = (s) => s.replace(/[\u202f\u00a0]/g, ' ')

/* Rev 27 P5: every scheduled time reads "Sun, Oct 11, 1:09 PM PDT", the
 * zone taken for that instant (so a November date reads PST in October), the
 * year only when it isn't this year. A zone en-US can't abbreviate reads
 * "GMT+2". */
 const formatSendTime = (iso, { weekday, now = new Date(), timeZone } = {}) => {
  const date = new Date(iso)
  const year = (d) => new Intl.DateTimeFormat('en-US', { year: 'numeric', timeZone }).format(d)
  return plainSpaces(new Intl.DateTimeFormat('en-US', {
    weekday: weekday ? 'short' : undefined,
    year: year(date) === year(now) ? undefined : 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone,
  }).format(date))
}; exports.formatSendTime = formatSendTime

/* "PDT": the zone abbreviation alone, for the instant given. */
 const formatZone = (date, timeZone) =>
  _nullishCoalesce(_optionalChain([new Intl.DateTimeFormat('en-US', { timeZoneName: 'short', timeZone })
, 'access', _ => _.formatToParts, 'call', _2 => _2(date)
, 'access', _3 => _3.find, 'call', _4 => _4(p => p.type === 'timeZoneName'), 'optionalAccess', _5 => _5.value]), () => ( '')); exports.formatZone = formatZone
